/*
|--------------------------------------------------------------------------
| Feed Preparsers: Common
|--------------------------------------------------------------------------
*/
/**
 * Common functionality for all feed preparsers that need it
 * @namespace
 */
__gh__webApp.feedPreparsers.common = {
		
	/**
	 * Returns a date stamp for an article
	 * "Posted Nov. 26, 2016 at 1:00 PM"
	 * @param {object} options
	 * @param {object} options.date - javascript new Date() object
	 * @param {string} options.dateType - "pubDate" or "modDate"
	 * @param {boolean} options.utc - true or false for utc date format ("2016-01-15")
	 * @param {boolean} options.hideTime - remove time from the time stamp
	 */
	"getDateString": function (options){
		var commonJS	= __gh__webApp.common;
			date 		= commonJS.getObjectProperty(options,"date",null),
			dateType 	= commonJS.getObjectProperty(options,"dateType","pubDate"),
			utc			= commonJS.getObjectProperty(options,"utc",false),
			hideTime	= commonJS.getObjectProperty(options,"hideTime",false);
		
		if (!date) { return ""; }
		var commonJS 		= __gh__webApp.common,
			monthShort		= commonJS.getMonthName(date,"short",utc),
			day				= (utc) ? date.getUTCDate() : date.getDate(),
			time 			= (hideTime) ? "" : "&nbsp;at&nbsp;"+ commonJS.getTimeFormatted(date,utc),
			action			= (dateType=="pubDate") ? "Posted&nbsp;" : "Updated&nbsp;";
		return action + monthShort +"&nbsp;"+ day + time;
	},
	
	
	/**
	 * Returns json for one item in our json format
	 * @param {object} item
	 * @param {string} [item.id=randomNumber] - unique id for article
	 * @param {object} item.date
	 * @param {object} item.date.pubDateObject - publication date for article - javascript new Date() object
	 * @param {object} item.date.modDateObject - modification date for article - javascript new Date() object
	 * @param {boolean} item.date.utcFormat - true or false for utc date format ("2016-01-15")
	 * @param {boolean} item.date.hideTime - hides the time from the dateTime string
	 * @param {string} [item.localStorageFeedURL=""] - local Storage feed url for article page - read more articles
	 * @param {string} [item.type="story] - "gallery", "story" etc.
	 * @param {string} [item.title=""] - title of item
	 * @param {string} [item.summary=""] - summary of item
	 * @param {string} [item.imageFocalPoint=""]
	 * @param {string} [item.byline=""]
	 * @param {boolean} [item.disableFetch=false]
	 * @param {string} [item.link=""] - link to the item
	 * @param {string} [item.shareLink=""] - share link for the item
	 * @param {string} [item.metered=false] - whether the item is premium content
	 * @param {string} [item.priority=""]
	 * @param {string} [item.category=""]
	 * @param {array} [item.taxonomy=[]] - array of taxonomy terms
	 * @param {object} [item.relatedContent={}] - related content
	 * @param {object} item.image
	 * @param {string} [item.image.link=null] - image link
	 * @param {string} [item.image.title=""] - image title
	 * @param {string} [item.image.orientation=""] - "L" or "P"
	 * @param {string} [item.image.credit=""] - image credit
	 * @param {string} [item.image.caption=""] - image caption
	 * @param {string} [item.image.myCapture=""] - my capture link
	 */
	"getItem": function(item){
		var commonPreparser = __gh__webApp.feedPreparsers.common,
			commonJS 		= __gh__webApp.common,
			pubDateObject 	= commonJS.getObjectProperty(item,"date.pubDateObject",new Date()),
			modDateObject	= commonJS.getObjectProperty(item,"date.modDateObject",null),
			dateUTCFormat	= commonJS.getObjectProperty(item,"date.utcFormat",false),
			dateHideTime	= commonJS.getObjectProperty(item,"date.hideTime",false),
			pubDateWeekday	= (modDateObject) ? commonJS.getDayName(modDateObject,"long",dateUTCFormat) : commonJS.getDayName(pubDateObject,"long",dateUTCFormat),
			imageLink;
			
			newItem = {
				"id"					: commonJS.getObjectProperty(item,"id",commonJS.getRandomNumber()),
				"localStorageFeedURL"	: commonJS.getObjectProperty(item,"localStorageFeedURL",""),
				"type"					: commonJS.getObjectProperty(item,"type","story"),
				"title"					: commonJS.getObjectProperty(item,"title",""),
				"summary"				: commonJS.getObjectProperty(item,"summary",""),
				"image"					: {},
				"imageFocalPoint"		: commonJS.getObjectProperty(item,"imageFocalPoint",""),
				"byline"				: commonJS.getObjectProperty(item,"byline",""),
				"pubDateWeekday"		: pubDateWeekday, //"Monday"
				"pubDate"				: commonPreparser.getDateString({
					"date"		: pubDateObject,
					"dateType"	: "pubDate",
					"utc"		: dateUTCFormat,
					"hideTime"	: dateHideTime
				}),
				"modDate"				: commonPreparser.getDateString({
					"date"		: modDateObject,
					"dateType"	: "modDate",
					"utc"		: dateUTCFormat,
					"hideTime"	: dateHideTime
				}),
				"isoPubDate"			: "",
				"isoModDate"			: "",
				"disableFetch"			: commonJS.getObjectProperty(item,"disableFetch",false),
				"link"	 				: commonJS.getObjectProperty(item,"link",""),
				"shareLink"				: commonJS.getObjectProperty(item,"shareLink",""),
				"metered"				: commonJS.getObjectProperty(item,"metered",false),
				"priority"				: commonJS.getObjectProperty(item,"priority",""),
				"category"				: commonJS.getObjectProperty(item,"category",""),
				"taxonomy" 				: commonJS.getObjectProperty(item,"taxonomy",[]),
				"relatedContent"		: commonJS.getObjectProperty(item,"relatedContent",{})
			};
	
	
		if (imageLink = commonJS.getObjectProperty(item,"image.link")) {
			newItem.image = {
				"link"			: imageLink,
				"orientation"	: commonJS.getObjectProperty(item,"image.orientation",""),
				"title"			: commonJS.getObjectProperty(item,"image.title",""),
				"credit"		: commonJS.getObjectProperty(item,"image.credit",""),
				"caption"		: commonJS.getObjectProperty(item,"image.caption",""),
				"myCapture"		: commonJS.getObjectProperty(item,"image.myCapture","")
			};
		}
	
		return newItem;
	}
};
